import React from 'react';

export const RevisionModal = ({
  isOpen,
  onClose,
  onSubmit,
  reason,
  setReason,
  testName,
  submitting = false,
}) => {
  if (!isOpen) return null;

  return (
    <div className="path-modal-overlay">
      <div className="path-modal-content">
        <div className="path-modal-header">
          <h3>✏️ Clinical Report Revision</h3>
          <button type="button" className="path-close-btn" onClick={onClose}>
            ✕
          </button>
        </div>

        <div className="path-modal-body">
          <div className="path-alert path-alert-warning">
            <strong>Audit Policy Notice:</strong> You are revising an already finalized & approved
            pathology report for <strong>{testName}</strong>. A documented clinical reason is mandatory
            and will be permanently recorded in the forensic delta audit trail.
          </div>

          <div className="path-form-group mt-3">
            <label className="path-label">
              Reason for Clinical Revision <span className="text-danger">*</span>
            </label>
            <textarea
              className="path-textarea"
              rows="4"
              placeholder="E.g., Analyzer optical sensor recalibration, repeat testing with double dilution confirmed revised titer..."
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              disabled={submitting}
            />
          </div>
        </div>

        <div className="path-modal-footer">
          <button
            type="button"
            className="path-btn path-btn-secondary"
            onClick={onClose}
            disabled={submitting}
          >
            Cancel
          </button>
          <button
            type="button"
            className="path-btn path-btn-warning"
            onClick={onSubmit}
            disabled={submitting || !reason.trim()}
          >
            {submitting ? 'Submitting Revision...' : 'Confirm & Save Revision'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default RevisionModal;
